import {useNavigate} from 'react-router-dom';
import {I18n} from '@aws-amplify/core';

import {AiOutlineEdit} from 'react-icons/ai';
import {
    FlexiButton,
    FlexiCancelButton
} from "@flexinet/ui-components";
import {useVerifiedPermissions} from '@flexinet/auth-components';
import {rbacActions} from "../../../config/rbac/actions.ts";
import {moduleConfig} from "../config";

// Edit opens the form drawer (§6, §7: Edit mirrors the Add chain). It used to swap the
// page into an inline form whose Cancel called nothing and which stayed in edit mode after
// a save.
export const useEditPageTools = ({onEdit}: { onEdit: () => void }) => {

    const navigate = useNavigate();

    const {allowedActions} = useVerifiedPermissions()

    const tools = [];

    if (allowedActions.includes(rbacActions.UpdateBillingProvider)) {
        tools.push(<FlexiButton leftSection={<AiOutlineEdit/>} variant={'filled'} key={'edit'}
                                onClick={onEdit}>{I18n.get('Edit')}</FlexiButton>);
    }

    tools.push(<FlexiCancelButton key={'close'}
                                  onClick={() => navigate(moduleConfig.basePath)}/>);

    return {
        tools,
    };

};
